import { addDays } from 'date-fns';
import React, { useState } from 'react';
import { DayPicker } from 'react-day-picker';
import { Colors } from '../../../ui';
import { DayPickerStyling } from '../../../ui/DayPickerStyling';
import { PickerItem, PickerMenu } from '../../../ui/PickerMenu';
import { Flexer, Title } from '../../dashboard/elements/LayoutElements';

const options = [
    { id: 'none', text: 'No due date' },
    { id: '3', text: 'Due in 3 days' },
    { id: '7', text: 'Due 7 days' },
    { id: '14', text: 'Due 14 days' },
    { id: '30', text: 'Due 30 days' },
    { id: 'custom', text: 'Pick...' },
];

export const SelectDueDateView = ({ onSelect }: { onSelect: (date: Date) => void }) => {

    const [custom, setCustom] = useState(false);

    const onPickInterval = (days: number) => {
        const date = new Date();
        date.setUTCHours(12, 0, 0, 0); // Set to 12pm UTC
        onSelect(addDays(date, days));
    };

    const onOption = (option: PickerItem) => {
        if (option.id === 'none') {
            onSelect(null);
        }
        else if (option.id === 'custom') {
            setCustom(true);
        }
        else {
            onPickInterval(parseInt(option.id));
        }
    };

    return <Flexer flex="column" width="18">
        <Flexer padding=".5 1" background={Colors.gray50} borderRadius=".5rem .5rem 0 0" borderBottom={`1px solid ${Colors.borderLight}`}>
            <Title flush size="2xs" color={Colors.text} uppercase weight="500">Action Due In...</Title>
        </Flexer>
        {!custom && <>
            <PickerMenu allowKeyboard items={options} onAction={onOption} />
        </>}
        {!!custom && <>
            <DayPickerStyling>
                <DayPicker
                    mode="single"
                    selected={new Date()}
                    onSelect={onSelect}
                    {...DayPickerStyling.modifiers({ allowPast: true })}
                />
            </DayPickerStyling>
        </>}
    </Flexer>;
};

